import type { GetServerSideProps } from 'next'
import type { FC, ReactNode } from 'react'
import type { Show } from '@/types'

import { Seo } from '@/components/generals/seo'
import { Navbar } from '@/components/landing/navbar'
import StreamShowcase from '@/components/landing/stream-showcase'
import { CTA } from '@/components/landing/cta'
import { Footer } from '@/components/landing/footer'

import { getShows } from '@/lib/shows'

interface HomeProps {
    shows: Show[]
}

const Home: FC<HomeProps> = ({ shows }): ReactNode => {
    return (
        <div id='top' className='flex min-h-screen flex-col bg-[#f5f5f7]'>
            <Seo />

            <Navbar />

            <main className='flex-1'>
                <StreamShowcase shows={shows} />
                <CTA />
            </main>

            <Footer />
        </div>
    )
}

export const getServerSideProps: GetServerSideProps<HomeProps> = async () => {
    const shows = await getShows()

    return {
        props: { shows }
    }
}

export default Home
